import Hint from '@components/Login/Hint';
import React, { ComponentProps } from 'react';
import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import useIsClinicianSubdomain from '@hooks/useIsClinicianSubdomain';

type ContactLinksHintProps = Omit<ComponentProps<typeof Hint>, 'children'>;

const ContactLinksHint = (props: ContactLinksHintProps) => {
  const { t } = useTranslation('common');
  const isClinicianSubdomain = useIsClinicianSubdomain();

  return (
    <Hint {...props}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <a
          data-testid="Instructions for use"
          href={`/regulatory/?activeTab=${isClinicianSubdomain ? 'clinician_instructions' : 'instructions'}`}
          target="_blank"
          rel="noreferrer"
        >
          {t('Instructions for use')}
        </a>
        <Divider type="vertical" />
        <a data-testid="Regulatory statement" href="/regulatory/?activeTab=regulatory" target="_blank" rel="noreferrer">
          {t('Regulatory statement')}
        </a>
      </div>
    </Hint>
  );
};

export default ContactLinksHint;
